module.exports = "h3 {\n    font-family: \"Raleway\" !important;\n    border-bottom: 1px solid #ccc9c9;\n    padding-bottom: 15px;\n    padding-right: 10px;\n    padding-left: 10px;\n    margin-bottom: 20px;\n    font-size: 18px;\n    font-weight: 300;\n}"


//////////////////
// WEBPACK FOOTER
// ./app/alarmas/alarmas.component.css
// module id = 924
// module chunks = 0